import { useState } from 'react'
import { getUniqueId } from '../registry'

export const useUniqueId = () => {
  const [uniqueId] = useState(getUniqueId)
  return uniqueId
}
